import { createContext, useContext, type ReactNode } from 'react';

export interface PanelSessionInboxPresentation {
  /** Null while the Backend's total is unknown; it is never a page count. */
  readonly knownUnreadCount: number | null;
  readonly content: ReactNode;
}

const PanelSessionInboxContext = createContext<PanelSessionInboxPresentation | null>(null);

export const PanelSessionInboxPresentationProvider = PanelSessionInboxContext.Provider;

/** Null outside a restaurant session, which has no inbox. */
export function usePanelSessionInboxPresentation(): PanelSessionInboxPresentation | null {
  return useContext(PanelSessionInboxContext);
}
